import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const FlexibleIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M9.99935 1.66675C5.40435 1.66675 1.66602 5.40508 1.66602 10.0001C1.66602 14.5951 5.40435 18.3334 9.99935 18.3334C14.5943 18.3334 18.3327 14.5951 18.3327 10.0001C18.3327 5.40508 14.5943 1.66675 9.99935 1.66675ZM13.3327 10.8334H9.53435C9.30018 10.8334 9.07602 10.7351 8.91852 10.5617L4.98518 6.24675C4.83102 6.07758 4.81935 5.81425 4.96852 5.64175C6.09352 4.34258 7.70768 3.47925 9.52435 3.35008C9.78268 3.33175 9.99935 3.54925 9.99935 3.80841V9.16675H13.3327C13.7927 9.16675 14.166 9.54008 14.166 10.0001C14.166 10.4601 13.7927 10.8334 13.3327 10.8334Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

FlexibleIcon.propTypes = {
  sx: PropTypes.object,
};

export default FlexibleIcon;
